export const RELATIONSHIPS = [
  'Agent',
  'Authorised Representative',
  'Broker',
  'Collection Agent',
  'Investigator',
  'Loss Adjuster',
  'Loss Assessor',
  'Partner',
  'Service Supplier Motor',
  'Service Supplier Property',
  'Third Party Administrator',
  'Underwriting Agency',
  'Other',
];

export const QBEBUSINESSLIST = ['Elders insurance', 'QBE insurance'];
